import { SEGMENT_NAMES } from '~publish/legacy/constants'

export function isCta(value: string | undefined): value is CTA {
  if (!value) return false

  if (
    value === SEGMENT_NAMES.COMPOSER_QUEUE_LIMIT ||
    value === SEGMENT_NAMES.QUEUE_LIMIT_BANNER_UPGRADE
  ) {
    return true
  }

  const parts = value.split('-')
  const product = parts[0]
  return (
    (product === 'publish' ||
      product === 'create' ||
      product === 'community') &&
    parts.length === 5 &&
    /^\d+$/.test(parts[4] ?? '')
  )
}
